import React from 'react';

interface CroppedStringProps {
    input: string;
    maxLength: number;
}

const CroppedText: React.FC<CroppedStringProps> = ({ input, maxLength }) => {
    if (input.length <= maxLength) {
        return <>{input}</>;
    }

    // Calculate the number of characters to show at the start and end.
    const charsToShow = Math.floor((maxLength - 1) / 2);
    const start = input.substring(0, charsToShow);
    const end = input.substring(input.length - charsToShow);

    return <>{`${start}…${end}`}</>;
};

export default CroppedText;
